import { useState, useEffect } from 'react';

import { useAppSelector } from '@app/store';

export interface ICategory {
  id: string;
  title?: string;
  titleAm?: string;
  titleEn?: string;
  titleRu?: string;
  nameAm?: string;
  nameEn?: string;
  nameRu?: string;
}

export const useCategories = () => {
  const [categories, setCategories] = useState<ICategory[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const token = useAppSelector((state: any) => state.auth.accessToken);

  useEffect(() => {
    setIsLoading(true);

    const customUrl = process.env.REACT_APP_API_BASE_URL || '';

    fetch(`${customUrl}/api/categories/dashboard?limit=100`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    })
      .then((res) => res.json())
      .then((data) => {
        if (data && data.categories) {
          const mapped = data.categories.map((c: any) => ({
            ...c,
            title: c.titleEn || c.titleAm || c.title || c.nameEn || c.nameAm || '',
            titleEn: c.titleEn || c.nameEn || c.title || '',
            titleAm: c.titleAm || c.nameAm || c.title || '',
            titleRu: c.titleRu || c.nameRu || '',
            nameEn: c.titleEn || c.nameEn || c.title || '',
            nameAm: c.titleAm || c.nameAm || c.title || '',
            nameRu: c.titleRu || c.nameRu || '',
          }));

          setCategories(mapped);
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  }, [token]);

  return { categories, isLoading };
};
